import { Box, Button } from "@mui/material";



function BackButton(props) {
    return (
        <Button
            onClick={props.onClick}
            sx={{
                display: "flext",
                width: "48px",
                height: "48px",
                color: "#383A3A",
                fontDamily: "Rowdies",
                borderRadius: "100px",
                minWidth: "20px",
                backgroundColor: "#F5F5F5",
                textTransform: "capitalize",
                transitionProperty: "background-color, box-shadow,transform,filter,bottom",
                transitionDuration: " 0.5s",
                '&:hover': {
                    backgroundColor: "#F5F5F5",
                    transform: "scale(1.1)",
                },
                '&:hover img': {
                    transitionProperty: "filter",
                    transitionDuration: " 0.5s",
                    filter: props.active ? "none" : "invert(1)"
                },
                '& img': {
                    transitionProperty: "background-color, box-shadow,transform,filter",
                    transitionDuration: " 0.5s",
                },
                "&::before":
                    props.border && {
                        content: '" "',
                        position: "absolute",
                        top: "-4px",
                        zIndex: "-1",
                        backgroundColor: " #ffffff75",
                        width: " 100%",
                        height: "100%",
                        borderRadius: "100px",
                        padding: "4px",

                    }

            }}
        >
            <Box
                sx={{
                    width: "12px",

                }}
                component="img"
                src="./assets/images/icons/ArrowLeft.svg"
            />
        </Button >
    )

}

export default BackButton